import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import PageHero from '../components/PageHero';
import CategoryGrid from '../components/CategoryGrid';
import './LandingPage.css';

function NotFound() {
  return (
    <div className="landing-page">
      <SEO title="Page Not Found" description="The page you were looking for could not be found." noindex />
      <PageHero
        title="Page Not Found"
        text="Sorry, we couldn't find that page. Browse our ceiling and drywall supplies or get in touch."
        actions={
          <>
            <Link to="/" className="btn btn-sky">Home</Link>
            <Link to="/products" className="btn btn-ghost">Products</Link>
            <Link to="/contact" className="btn btn-ghost">Contact Us</Link>
          </>
        }
      />
      <section className="section section-white">
        <div className="container">
          <CategoryGrid />
        </div>
      </section>
    </div>
  );
}

export default NotFound;
